/* eslint-disable no-console */
/* eslint-disable no-unused-vars */
import { appStore } from "@app/store/store"
import { ApiErrorHandler } from "@app/utils/apiErrorHandler"
import { groupBy } from "@app/utils/objectUtils"
import { createApi, createBaseQuery } from "@tecreation/js-state-react"

const transformImages = (data, url, accessToken) => {
	const generateUrls = obj => {
		Object.keys(obj).forEach(field => {
			if (obj[field] !== null && typeof obj[field] === "object") {
				return generateUrls(obj[field])
			}
			if (
				obj[field] !== null &&
				typeof obj[field] === "string" &&
				/^[a-zA-Z0-9]{8}-[a-zA-Z0-9]{4}-[a-zA-Z0-9]{4}-[a-zA-Z0-9]{4}-[a-zA-Z0-9]{12}$/.test(obj[field])
			) {
				obj[field] = `${url}/${obj[field]}?access_token=${accessToken}`
			}
		})
		return data
	}
	return generateUrls(data)
}

const transformTranslations = (data, key = "translations") => {
	Object.keys(data).forEach(field => {
		if (data[field]) {
			if (Array.isArray(data[field])) {
				data[field].forEach((e, i, a) => {
					if (a[i][key]) {
						a[i] = {
							...a[i],
							...a[i][key][0],
						}
						delete a[i][key]
						a[i] = transformTranslations(a[i])
					} else if (typeof a[i] === "object") {
						a[i] = transformTranslations(a[i])
					}
				})
			} else if (typeof data[field] === "object") {
				if (data[field][key]) {
					data[field] = {
						...data[field],
						...data[field][key][0],
					}

					delete data[field][key]

					data[field] = transformTranslations(data[field])
				}
			}
		}
	})
	return data
}

const baseQueryOptions = {
	baseUrl: () => {
		return appStore.get("settings.cmsUrl")
	},
	paramsSerializer: params => {
		const adjustedParams = {
			...params,
			deep: params.deep || {},
		}
		if (adjustedParams.filter) {
			adjustedParams.filter = JSON.stringify(params.filter)
		}

		if (!adjustedParams.deep["translations"]) {
			adjustedParams.deep["translations"] = {
				_filter: {
					languages_code: {
						_eq: appStore.getState().core.locale,
					},
				},
			}
		}

		adjustedParams.deep = JSON.stringify(adjustedParams.deep)
		adjustedParams.access_token = appStore.get("settings.cmsKey")

		let delemiter = ""
		let paramString = ""

		for (let key of Object.keys(adjustedParams)) {
			paramString += delemiter + key + "=" + adjustedParams[key]
			if (delemiter === "") {
				delemiter = "&"
			}
		}
		return paramString
	},
	transformResponse: response => {
		if (response.data) {
			response.data = transformImages(response.data, appStore.get("settings.cmsAssetsUrl"), appStore.get("settings.cmsKey"))
			response.data = transformTranslations(response.data)
		}
		return {
			...response,
			data: response.data ? response.data.data : undefined,
		}
	},
	onError: ApiErrorHandler,
}

const locationBaseQueryOptions = {
	baseUrl: () => {
		return appStore.get("settings.locationCmsUrl")
	},
	paramsSerializer: params => {
		const adjustedParams = {
			...params,
			deep: params.deep || {},
		}
		if (adjustedParams.filter) {
			adjustedParams.filter = JSON.stringify(params.filter)
		}

		if (!adjustedParams.deep["translations"]) {
			adjustedParams.deep["translations"] = {
				_filter: {
					languages_code: {
						_eq: appStore.getState().core.locale,
					},
				},
			}
		}

		adjustedParams.deep = JSON.stringify(adjustedParams.deep)
		adjustedParams.access_token = appStore.get("settings.locationCmsKey")

		let delemiter = ""
		let paramString = ""

		for (let key of Object.keys(adjustedParams)) {
			paramString += delemiter + key + "=" + adjustedParams[key]
			if (delemiter === "") {
				delemiter = "&"
			}
		}
		return paramString
	},
	transformResponse: response => {
		if (response.data) {
			response.data = transformImages(response.data, appStore.get("settings.locationCmsAssetsUrl"), appStore.get("settings.locationCmsKey"))
			response.data = transformTranslations(response.data)
		}
		return {
			...response,
			data: response.data ? response.data.data : undefined,
		}
	},
	onError: ApiErrorHandler,
}

export const cmsApiSlice = createApi("cmsApi", appStore, createBaseQuery(baseQueryOptions), {
	keepUnusedDataFor: 360,
})

export const locationCmsApiSlice = createApi("locationCmsApi", appStore, createBaseQuery(locationBaseQueryOptions), {
	keepUnusedDataFor: 360,
})

export const useGetZones = locationCmsApiSlice.query({
	name: "getZones",
	builder: params => ({
		url: "zone",
		params: {
			fields: ["image", "imagePricePin", "zoneId", "translations.*", "zoneId", "color", "useLoungers", "roundPrices"],
		},
	}),
})

export const useGetZonePricePin = locationCmsApiSlice.query({
	builder: ({ zoneId }) => ({
		url: "zonePricePin",
		params: {
			fields: ["translations.pricePin"],
			filter: {
				zone: {
					zoneId: {
						_eq: zoneId,
					},
				},
				funnel: {
					funnelToken: {
						_eq: appStore.get("settings.funnelToken"),
					},
				},
			},
		},
	}),
	transformResponse: rsp => {
		if (rsp.succeed) {
			rsp.data = rsp.data[0]
		}
		return rsp
	},
})

export const useGetActivityGroups = locationCmsApiSlice.query({
	name: "getActivites",
	builder: params => ({
		url: "activityGroup",
		params: {
			fields: ["*,image", "translations.*", "single.activity_id.*", "pair.activity_id.*"],
		},
	}),
	transformResponse: response => {
		const result = response.data
		result.forEach(e => {
			const single = []
			e.single.forEach(s => {
				single.push(s.activity_id)
			})
			e.single = single
			const pair = []
			e.pair.forEach(s => {
				pair.push(s.activity_id)
			})
			e.pair = pair
		})
		result.sort((a, b) => {
			return a.title > b.title ? 1 : a.title < b.title ? -1 : 0
		})
		console.log(result)
		response.data = result
		return response
	},
})

export const useGetLinks = cmsApiSlice.query({
	name: "getLinks",
	builder: () => ({
		url: "locationLinks",
		params: {
			fields: ["*,translations.*"],
			filter: {
				location: {
					locationId: {
						_eq: appStore.get("core.locationId"),
					},
				},
			},
		},
	}),
	transformResponse: response => {
		if (response.succeed) {
			response.data = response.data[0] || undefined
		}

		return response
	},
})

export const useGetStrings = cmsApiSlice.query({
	name: "getStrings",
	builder: params => ({
		url: "strings",
		params: {
			fields: ["translations.*, translations2.*"],
			deep: {
				translations2: {
					_filter: {
						languages_code: {
							_eq: appStore.getState().core.locale,
						},
					},
				},
			},
		},
	}),
	transformResponse: response => {
		const t2 = transformTranslations({ data: { translations: response.data.translations2 } })
		delete response.data.translations2

		response.data = {
			...response.data,
			...t2.data,
		}

		return response
	},
})
export const useGetPaymentGroups = locationCmsApiSlice.query({
	name: "getPaymentGroups",
	builder: params => ({
		url: "paymentGroup",
		params: {
			fields: [
				"translations.*",
				"image",
				"darkThemedImage",
				"type",
				"funnels.paymentId",
				"funnels.paymentDetailIds.payment_id.paymentDetailId",
				"funnels.paymentDetailIds.payment_id.*",
			],
			filter: {
				funnels: {
					funnel: {
						funnelToken: {
							_eq: appStore.get("settings.funnelToken"),
						},
					},
				},
			},
			deep: {
				funnels: {
					_filter: {
						funnel: {
							funnelToken: {
								_eq: appStore.get("settings.funnelToken"),
							},
						},
					},
				},
			},
		},
	}),
	transformResponse: response => {
		if (response.succeed) {
			for (let entry of response.data) {
				entry.paymentId = entry.funnels[0].paymentId
				entry.paymentDetailIds = entry.funnels[0].paymentDetailIds.map(e => e.payment_id.paymentDetailId)
				entry.payments = entry.funnels[0].paymentDetailIds.map(e => e.payment_id)
			}
		}
		return response
	},
})

export const useGetZone = (zoneId, queryOptions) => {
	const zones = useGetZones(undefined, queryOptions)

	let defaultV = queryOptions && queryOptions.defaultData !== undefined ? {} : undefined

	return {
		...zones,
		data: zones.data && Array.isArray(zones.data) ? zones.data.find(e => e.zoneId === zoneId) || defaultV : defaultV,
	}
}

export const useGetLoungerTypes = locationCmsApiSlice.query({
	name: "getLoungerTypes",
	builder: ({ zoneId }) => ({
		url: "lounger",
		params: {
			fields: ["*", "translations.*"],
			filter: {
				zoneId: zoneId
					? {
							zoneId: {
								_eq: zoneId,
							},
						}
					: undefined,
			},
			sort: ["price, objectGroup"],
		},
	}),
	transformResponse: (data, calledArgs) => {
		data.data = groupBy(data.data, "style")
		return data
	},
})

export const useGetBluphoriaProducts = cmsApiSlice.query({
	name: "getBluphoriaProducts",
	builder: params => ({
		url: "bluphoriaArticleGroup",
		params: {
			fields: ["*", "translations.*", "articles.article_id.articleId"],
			filter: {
				locationId: {
					locationId: {
						_eq: appStore.getState().core.locationId,
					},
				},
			},
			deep: {
				articles: {
					article_id: {
						translations: {
							_filter: {
								languages_id: {
									_eq: appStore.getState().core.locale,
								},
							},
						},
						properties: {
							property: {
								translations: {
									_filter: {
										languages_code: {
											_eq: appStore.getState().core.locale,
										},
									},
								},
							},
						},
					},
				},
			},
		},
	}),
	transformResponse: data => {
		data.data.forEach((e, i, a) => {
			a[i].articles.forEach((r, o, s) => {
				s[o] = {
					...s[o].article_id,
				}
				delete s[o].article_id

				if (s[o].properties) {
					s[o].properties.forEach((t, p, d) => {
						d[p] = {
							...d[p].property,
						}
						delete d[p].property
					})
				}
			})
		})

		return data
	},
})

export const useGetProducts = locationCmsApiSlice.query({
	name: "getBluphoriaProducts2",
	builder: params => ({
		url: "article",
		params: {
			fields: [
				"translations.*",
				"gallery.directus_files_id",
				"articleId",
				"basePrice",
				"price",
				"weight",
				"baseEntity.short",
				"entity.short",
				"translations.title",
				"translations.description",
			],
			limit: -1,
		},
	}),
	transformResponse: data => {
		data.data.forEach((e, i, a) => {
			if (a[i].properties) {
				a[i].properties.forEach((t, p, d) => {
					d[p] = {
						...d[p].property,
					}
					delete d[p].property
				})
			}
		})

		return data
	},
})

export const useGetUpsellArticles = locationCmsApiSlice.query({
	name: "getUpsellArticles",
	builder: () => ({
		url: "upsellArticle",
		params: {
			fields: ["*", "translations.*"],
			filter: {
				type: {
					_eq: "ticket",
				},
				funnelToken: {
					_eq: appStore.get("settings.funnelToken"),
				},
			},
			sort: ["price"],
		},
	}),
})

export const useGetLocation = locationCmsApiSlice.query({
	builder: () => ({
		url: "location",
		params: {
			fields: ["*.*", "availableMassageZones.zone_id.zoneId"],
		},
	}),
	transformResponse: rsp => {
		if (rsp.succeed) {
			rsp.data?.availableMassageZones?.forEach((e, i, a) => {
				a[i] = e.zone_id.zoneId
			})
		}

		return rsp
	},
})

export const useGetMyParadiseImages = cmsApiSlice.query({
	builder: () => ({
		url: "myParadiseImages",
		params: {
			fields: ["*"],
			filter: {
				location: {
					locationId: {
						_eq: appStore.get("core.locationId"),
					},
				},
			},
		},
	}),
})

export const useGetMyParadiseImage = ({ type }) => {
	const result = useGetMyParadiseImages()
	let image = result.data ? result.data.find(e => e.type === type) : undefined
	return {
		...result,
		data: image ? image.image : undefined,
	}
}

export const useGetBankTemplate = locationCmsApiSlice.query({
	name: "useGetBankTemplate",
	builder: () => ({
		url: "bankAccountTemplate",
		params: {
			fields: ["*", "translations.*", "accountGroupId.isEmployee"],
			filter: {
				status: {
					_eq: "published",
				},
			},
		},
	}),
	transformResponse: rsp => {
		rsp.data.sort((a, b) => {
			if (a.amount > b.amount) return 1
			if (a.amount < b.amount) return -1
			if (a.amount == b.amount) return 0
		})

		return rsp
	},
})

export const useGetArticles = locationCmsApiSlice.query({
	name: "getArticles",
	builder: () => ({
		url: "article",
		params: {
			fields: ["*", "translations.*", "gallery.*"],
			filter: {
				_and: [
					{
						funnels: {
							funnel_id: {
								funnelToken: {
									_eq: appStore.get("settings.funnelToken"),
								},
							},
						},
					},
					{
						_or: [
							{
								isVoucher: {
									_eq: false,
								},
							},
							{
								isVoucher: {
									_null: true,
								},
							},
						],
					},
				],
			},
			limit: -1,
		},
	}),
})

export const useGetVouchers = locationCmsApiSlice.query({
	name: "getArticles",
	builder: () => ({
		url: "article",
		params: {
			fields: ["*", "translations.*", "gallery.*"],
			filter: {
				_and: [
					{
						funnels: {
							funnel_id: {
								funnelToken: {
									_eq: appStore.get("settings.funnelToken"),
								},
							},
						},
					},
					{
						_or: [
							{
								isVoucher: {
									_eq: true,
								},
							},
						],
					},
				],
			},
			sort: ["+price"],
			limit: -1,
		},
	}),
})
